import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'

const FeatureStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${media.phone} {
    flex-direction: row;
    justify-content: flex-start;
  }
`

const FeatureMediaStyled = styled.div`
  margin-bottom: 1.875rem;

  @media ${media.phone} {
    margin-bottom: 0;
  }
`

const FeatureContentStyled = styled.div<WithTheme>`
  text-align: center;
  @media ${media.phone} {
    width: calc(100% - 16.5625rem);
    text-align: left;

    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            padding-right: 4.875rem;
            text-align: right;
          `
        : css`
            padding-left: 4.875rem;
          `}
  }
`

const FeatureContentHeadStyled = styled.div`
  margin-bottom: 1.5rem;
  @media ${media.phone} {
    margin-bottom: 2.25rem;
  }
`

const FeatureContentBodyStyled = styled.div`
  margin-bottom: 2.5rem;
  @media ${media.phone} {
    margin-bottom: 2.875rem;
  }
`

const FeatureContentFooterStyled = styled.div``

export {
  FeatureStyled,
  FeatureMediaStyled,
  FeatureContentStyled,
  FeatureContentHeadStyled,
  FeatureContentBodyStyled,
  FeatureContentFooterStyled
}
